<template>
  <div class="pcg-notstarted d-flex text-center">
    <div class="mx-auto mt-5 pt-5">
      <div style="width: 250px;">
        <p> {{ translation.general.notStarted }}</p>
      </div>
      <div class="mb-4 mt-4">
        <img src="./img/Chimchar.gif" alt="starter" class="pcg-notstarted__starter">
        <img src="./img/Treecko.gif" alt="starter" class="pcg-notstarted__starter pcg-notstarted__starter--low">
        <img src="./img/Totodile.gif" alt="starter" class="pcg-notstarted__starter">
      </div>

      <button @click="refreshIfUserStarted()" :disabled="isBlocked"
              class="btn btn-link poketwitch__header-btn--refresh pcg-notstarted-refresh">
        <svg class="bi bi-arrow-clockwise" width="50px" height="50px" viewBox="0 0 16 16" fill="currentColor"
             xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
                d="M3.17 6.706a5 5 0 0 1 7.103-3.16.5.5 0 1 0 .454-.892A6 6 0 1 0 13.455 5.5a.5.5 0 0 0-.91.417 5 5 0 1 1-9.375.789z"/>
          <path fill-rule="evenodd"
                d="M8.147.146a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 1 1-.707-.708L10.293 3 8.147.854a.5.5 0 0 1 0-.708z"/>
        </svg>
      </button>

    </div>
  </div>
</template>

<script>
import {translation} from "@/utils/translations";
import {currentView} from "@/utils/globals";
import {backendUri, firstView} from "@/utils/settings";
import {showModalMsg} from "@/components/Modal/modalUtils";
import {blockButton, isBlocked, unblockButton} from "@/components/ButtonControl/ButtonControl";
import axios from 'axios';


export default {
  name: "NotStarted",
  setup() {

    const refreshIfUserStarted = async () => {
      blockButton();
      setTimeout(function () {
        unblockButton();
      }, 3000);

      await axios.get(backendUri + "api/game/ext/ping/")
          .then(() => {
            currentView.value = firstView;
          })
          .catch(() => {
            showModalMsg(translation.general.notStartedDiscord);
          })
    }

    return {
      translation,
      refreshIfUserStarted,
      isBlocked
    }
  }
}

</script>

<style scoped lang="scss">
@import '@/scss/variables';

.pcg-notstarted {
  &-refresh {
    color: white;
    width: 100px;
    height: 100px;
  }

  background-color: $poketwitch-branding-color;
  color: white;
  font-family: "Josefin Sans", sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;

  &__starter {
    width: 80px;

    &--low {
      padding-top: 100px;
    }
  }
}
</style>